module.exports = __webpack_public_path__ + "img/walk_sign.65b6cceb.jpg";